export default __webpack_public_path__ + "static/media/speaker.ce5b8a3f.svg";